<template>
  <div
    class="sc-upload"
    :class="[
      isMainImg ? 'mainImg' : '',
      draggable ? 'draggable' : '',
      isSingle ? 'isSingle' : '',
      croping ? 'croping' : ''
    ]">
    <div v-if="autoCropImageParams && hasSizeError"><el-button type="link" @click="fixImgSize()">一键修正尺寸不符图片</el-button></div>
    <template v-if="imgUrl">
      <div class="file-img" :class="[limitError ? 'limitError' : '']" :style="[itemSizeStyle]">
        <template v-if="buildOssImgUrl(imgUrl) !== imgUrl">
          <img ref="img" class="buildOssImgUrl" :src="buildOssImgUrl(imgUrl)" referrerpolicy="no-referrer"/>
          <img ref="originImg" class="originImg" style="display: none;" @load="handleLoad" @error="loadError" :src="imgUrl" referrerpolicy="no-referrer"/>
        </template>
        <template v-else>
          <img ref="originImg" class="originImg" :src="imgUrl" @load="handleLoad" @error="loadError" referrerpolicy="no-referrer"/>
        </template>
        <div class="mainImgNum" v-if="mainImgSortNum && isMainImg"> 主图{{mainImgSortNum}} </div>
        <div v-if="showAuditResult && matchAuditImage" class="audit-btn">
          <el-tooltip
            class="item"
            effect="dark"
            :content="matchAuditTips"
            placement="top"
            popper-class="audit-result-tooltip"
          >
            <i class="el-icon-warning" />
          </el-tooltip>
        </div>
        <div v-if="!onlyPreview && !isPureType" @click="openAiDrawer" class="ai-edit-btn"> AI改图 </div>
        <div class="btn-row" v-if="!onlyPreview && !isPureType">
          <div @click="edit(false)" class="edit-btn"> 编辑 </div>
          <div v-if="imgCache[imgUrl]" @click="recover(imgCache[imgUrl])" class="recover-btn"> 恢复 </div>
        </div>
        <div v-if="!onlyPreview && !isPureType" @click="del" class="del-btn"> <i class="el-icon-close" /></div>
        <!-- <div v-if="!onlyPreview && !isPureType" @click="edit(true)" class="crop-btn"><i class="el-icon-crop" /></div> -->
        <div @click="preview" class="preview-btn"><i class="el-icon-ai44" /></div>
      </div>
    </template>
    <el-upload
      v-else
      ref="upload"
      class="file-input"
      :class="[(upload_err || emptyError) ? 'error-warp' : '']"
      action="#"
      :disabled="uploading || onlyPreview || isPureType"
      :accept="limitSuffix"
      :drag="draggable"
      :file-list="fileList"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="!isSingle"
      :on-change="handleChange"
      :before-upload="beforeUpload"
      :style="[itemSizeStyle]">
      <div class="file-input-icon" slot="default" :style="[itemSizeStyle]">
        <template v-if="uploading"> 
          <i class="el-icon-loading"></i>
          <span class="upload-text">上传中</span>
        </template>
        <template v-else-if="upload_err">
          <i class="el-icon-chaoshibiaoqing"></i>
          <span class="upload-text">{{errMsg}}</span>
          <div v-if="!isSingle" @click.stop="del" class="del-btn" style="display: flex"> <i class="el-icon-close" /> </div>
        </template> 
        <i v-else class="el-icon-picture-outline"></i>
        <div class="upload-btns" v-if="!onlyPreview && !isPureType">
          <template v-if="upload_err">
            <div class="retry-upload" @click.stop="retryUpload">重试</div>
            <div class="location-upload"> 本地上传 </div>
            <div class="material-space-upload" @click.stop="handleOpenPictureZone">素材空间上传</div>
          </template>
          <template v-else>
            <div class="location-upload"> 本地上传 </div>
            <div class="material-space-upload" @click.stop="handleOpenPictureZone">素材空间上传</div>
          </template>
        </div>
      </div>
    </el-upload>
    <div class="img-correct-box" v-if="Object.keys(imgCache).length">
      <div class="img-correct-tip" v-if="imgCache[imgUrl]"><i class="el-icon-success" />已修正</div>
    </div>
    <!-- AI生图状态指示 -->
    <div v-if="aiStatus" class="ai-status-indicator">
      <template v-if="aiStatus.status === 'done'">
        <span class="ai-status-text done">已生图</span>
      </template>
      <template v-else-if="aiStatus.status === 'failed'">
        <span class="ai-status-text failed">生图失败</span>
        <el-button v-if="!retrying" type="text" size="mini" @click.stop="handleAiRetry" class="ai-retry-btn">重新生成</el-button>
      </template>
      <template v-else-if="aiStatus.status === 'pending' || aiStatus.status === 'running'">
        <span class="ai-status-text pending">正在生图中</span>
      </template>
      <template v-else-if="aiStatus.status === 'retrying'">
        <span class="ai-status-text retrying">正在重试中</span>
      </template>
    </div>
    <div class="imgName" v-if="imgName" :style="{width: `${width}px`, 'white-space': 'break-spaces'}">{{imgName}}</div>
    <div>
      <el-button @click="handleSettingSearchImg"  v-if="showSettingSearchImgBtn" class="highlight-btn" >设置为搜索图</el-button>
    </div>
    <AdvancedImagePreview 
      :visible="dialogVisible"
      :imageList="previewImageList"
      :initialIndex="previewIndex"
      @close="closePreview" />
    <Crop @success="handleCropFile" ref="crop" />
    <Editor ref="editRef" />
    <ProdImageEditorDrawer v-if="imageEditorDrawerVisible" ref="imgEditorDrawerRef" @on-save="handleImgEditorSave" @on-save-batch="handleImgEditorSaveBatch" />
    <AiEditor ref="aiEditor" />
    <ChoosePictrueZone v-show="choosePictrueZoneVisible" ref="choosePictrueZoneRef"/>
    <ChooseNewPictrueZone v-show="chooseNewPictrueZoneVisible" :appendToBody="appendToBody" ref="chooseNewPictrueZoneRef"/>
  </div>
 
</template>

<script>
import OSSClient from './OSS-client'
import Crop from "./Crop/index.vue";
import Editor from "./Editor/index";
import ProdImageEditorDrawer from './ProdImageEditorDrawer.vue';
import ChoosePictrueZone from "./ChoosePictrueZone.vue";
import ChooseNewPictrueZone from "./ChooseNewPictrueZone.vue";
import AdvancedImagePreview from './AdvancedImagePreview.vue';
import { buildOssImgUrl } from '@/utils/oss-img';
import { getBase64, getImgFileSize } from '@/api/base/index.js';
import { mapActions, mapGetters } from 'vuex';
import { _getImageSize } from '@/store/modules/image';
import AiEditor from './Editor/AiEditor.vue';
import { batchFixImages } from '@/servers/prod/center/index'

const allSuffix = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
export default {
  inject: {
    elFormItem: { default: null },
    injectedOuterId: { default: () => '', from: 'outerId' },
    // AI生图相关 - 从EditDialog通过provide注入
    aiTaskItemsData: { default: () => [] },
    aiRetryFn: { default: () => null },
  },
  components: {
    Crop,
    Editor,
    ProdImageEditorDrawer,
    ChoosePictrueZone,
    ChooseNewPictrueZone,
    AdvancedImagePreview,
    AiEditor
  },
  props: {
    colorId: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 80
    },
    height: {
      type: [Number, String],
      default: 80
    },
    file: {
      type: [String, Object],
      default: ''
    },
    isSingle: {
      type: Boolean,
      default: false
    },
    isMainImg: {
      type: Boolean,
      default: false
    },
    mainImgSortNum: {
      type: [Boolean, Number],
      default: false
    },
    draggable: {
      type: Boolean,
      default: true
    },
    limitSize: { // 字节大小限制
      type: Number,
      default: 0
    },
    size: { // 处理 oss 图片url,缩略图尺寸
      type: Number,
      default: 0
    },
    limitWidth: { // 限制宽度
      type: Array,
      default() { // 0表示不限制
        return [0, 0]
      } 
    },
    limitHeight: { // 限制高度
      type: Array,
      default() { // 0表示不限制
        return [0, 0]
      } 
    },
    aspectRatioRange: { 
      type: Array,
      default() { // 0表示不限制
        return [0, 0]
      } 
    },
    aspectRatio: { // 限制长宽比 width/height
      type: [Number, Array],
      default: 0
    },
    aspectRatioText: { // 长宽比文案
      type: String,
      default: ''
    },
    aspectRatioLimitWidth: { // 限制了长宽比时，不同宽高比的宽度限制
      type: Array,
      default() { 
        return []
      } 
    },
    limitSuffix: { // 图片后缀类型 英文逗号拼接
      type: String,
      default: '.jpg,.jpeg,.png,.gif'
    },
    strictSuffix: { // 是否严格校验后缀类型
      type: Boolean,
      default: false
    },
    onlyPreview: { // 只能预览｜上传、移除操作不允许
      type: Boolean,
      default: false
    },
    uploadFunc: {
      type: Function
    },
    index: Number,
    validated: Boolean,
    valiErrMsg: String,
    isPureType: {
      type: Boolean
    },
    isSquare:{
      type:Boolean,
      default:false
    },
    cropDefaultSize: {
      type: Array,
      default: () => {
        return [800, 800]
      }
    },
    showAuditResult: {
      type: Boolean,
      default: false
    },
    auditFileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    needAutoCrop: {
      type: Boolean,
      default: false
    },
    showSettingSearchImgBtn:{
      type: Boolean,
      default: false
    },//外部控制传入，上传图片组件是否展示【设置为搜索图】按钮，默认不展示
    originFile: {
      type: Object
    },
    isCheckImg:{
      type: Boolean,
      default: true
    },
    imgName:{
      type: String,
      default: ''
    },
    showSearchImgType:{
      type: Number,
    },
    // 商品ID（用于素材空间场景传递给子页面）
    productId: {
      type: String,
      default: ''
    },
    autoCropImageParams:{
      type: [Object,null],
      default:()=>{
        return null
      }
    },
    fixImgCache:{ // 一键修正图片，做个映射，用于缓存新图和老图
      type:Object,
      default:()=>{
        return {}
      }
    },
    emptyError:{ // 图片为空(未上传)时 报错提示
      type:Boolean,
      default:false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    outerId: {
      type: String,
      default: ''
    },
    supportAiRetry: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imgUrl: '',
      fileList: [],
      uploading: false,
      croping: false,
      upload_err: false,
      errMsg: '',
      dialogVisible: false,
      previewImageList: [],
      previewIndex: 0,
      mainImgWatch: null,
      limitError: false,
      errMessageIns: null,
      fileChangeBuffer: [],
      bufferTimer: null,
      imgDomReady: false,
      imgError: false,
      currentUploadFile: null,
      choosePictrueZoneVisible: false,
      chooseNewPictrueZoneVisible: false,
      imageEditorDrawerVisible: false,
      dimensionsCache: null,
      imageLoadPromise: null,
      resolvedProductIdCache: '',
      hasSizeError:false,
      imgCache: {},
      retrying: false, // AI生图重试中
    }
  },
  computed: {
    ...mapGetters(["imageCacheSizes",'defaultSearchImageList']),
    highlightSearchType() {
      return this.defaultSearchImageList.some(item => 
        item.imageUrls === this.imgUrl && item.colorId === this.colorId
      ) ? 'primary' : 'default'
    },
    // AI生图状态
    aiStatus() {
      if(!this.supportAiRetry) return null
      const taskItemsData = typeof this.aiTaskItemsData === 'function' ? this.aiTaskItemsData() : this.aiTaskItemsData
      if (!taskItemsData || !taskItemsData.length || !this.imgUrl) return null
      // 正在重试中
      if (this.retrying) {
        const taskItem = taskItemsData.find(t => t.sourceImageUrl === this.imgUrl)
        if (taskItem) return { status: 'retrying', sourceImageUrl: taskItem.sourceImageUrl, id: taskItem.id, taskId: taskItem.taskId, businessId: taskItem.businessId, sourceIndex: taskItem.sourceIndex }
      }
      // 匹配状态
      for (const task of taskItemsData) {
        if (task.taskStatus === 'DONE' && task.resultImageUrl === this.imgUrl) {
          return { status: 'done', sourceImageUrl: task.sourceImageUrl, resultImageUrl: task.resultImageUrl, id: task.id, taskId: task.taskId, businessId: task.businessId, sourceIndex: task.sourceIndex }
        }
        if (task.sourceImageUrl === this.imgUrl) {
          if (task.taskStatus === 'FAILED') {
            return { status: 'failed', errorMsg: task.errorMsg, sourceImageUrl: task.sourceImageUrl, id: task.id, taskId: task.taskId, businessId: task.businessId, sourceIndex: task.sourceIndex }
          }
          if (task.taskStatus === 'PENDING' || task.taskStatus === 'RUNNING') {
            return { status: task.taskStatus === 'RUNNING' ? 'running' : 'pending', sourceImageUrl: task.sourceImageUrl, id: task.id, taskId: task.taskId, businessId: task.businessId, sourceIndex: task.sourceIndex }
          }
        }
      }
      return null
    },
    itemSizeStyle() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
      }
    },
    companyId() {
      return this.$store.getters.userInfo.companyId;
    },
    productIdResolved() {
      return this.productId || ''
    },
    effectiveOuterId() {
      return this.outerId || this.injectedOuterId
    },
    matchAuditImage() {
      return this.showAuditResult && 
        this.auditFileList.some(item => item.originUrl === this.imgUrl)
    },
    matchAuditTips() {
      const matchList = this.auditFileList.filter(item => {
        return item.originUrl === this.imgUrl;
      });
      const auditResultMap = {
        fx: {
          1: '待审核',
          2: '审核中',
          3: '审核通过',
          4: '审核失败'
        },
        tb: {
          100: '未审核没冻结',
          101: '被冻结',
          102: '审核通过',
        }
      }
      const tips = matchList.map(item => {
        const auditResult = auditResultMap[item.platformType][item.auditStatus];
        return `店铺【${item.shopName}】，该图片「${auditResult}」`
      });
      return tips.join('；')
    },
    // 与路由保持一致：根据公司注册时间切换新旧素材空间
    useNewPictureZone() {
      let companyCreated = 0;
      try {
        const raw = window.localStorage.getItem('userinfo');
        if (raw) {
          const u = JSON.parse(raw);
          companyCreated = Number(u && u.companyCreated) || 0;
        }
      } catch (e) {}
      // 固定阈值：2026-03-01 00:00:00（本地时区）
      const START_TS = new Date(2026, 2, 1, 0, 0, 0).getTime();
      return companyCreated >= START_TS;
    }
  },
  watch: {
    productIdResolved: {
      immediate: true,
      handler(v) {
        this.resolvedProductIdCache = v || ''
      }
    },
    imgUrl: {
      immediate: true,
      handler(newUrl, oldUrl) {
        if (newUrl !== oldUrl) {
          this.imgDomReady = false;
          this.imgError = false;
          // 清除缓存
          this.dimensionsCache = null;
          this.imageLoadPromise = null;
        }
      }
    },
    file: {
      immediate: true,
      handler(newVal) {
        this._init_file(newVal);
      }
    },
    fixImgCache:{
      handler(newVal) {
        this.imgCache = newVal;
      },
      deep: true,
      immediate: true
    },
  },
  created() {
    // 冻结静态配置，提升性能
    Object.freeze(this.cropDefaultSize);
    Object.freeze(this.limitWidth);
    Object.freeze(this.limitHeight);
    Object.freeze(this.aspectRatioLimitWidth);
  },
  beforeDestroy() {
    // 清理定时器和资源
    this.clearBufferTimer();
    if (this.errMessageIns) {
      this.errMessageIns.close();
      this.errMessageIns = null;
    }
    this.dimensionsCache = null;
    this.imageLoadPromise = null;
  },
  methods: {
    ...mapActions(['cacheImageFileSize']),
    // 打开 AI 改图抽屉
    openAiDrawer() {
      if (!this.imgUrl) {
        this.$message && this.$message.warning('请先上传图片');
        return;
      }
      const imgName = this.imgName || (this.file && this.file.name) || 'image.jpg';
      try {
        if (this.$refs && this.$refs.aiEditor && this.$refs.aiEditor.method_open) {
          this.$refs.aiEditor.method_open({
            imgUrl: this.imgUrl,
            imgName,
            productCode: this.effectiveOuterId,
            label: this.elFormItem?.label || '',
            okFn: (newUrl) => {
              if (newUrl && typeof newUrl === 'string') {
                this.updateImgUrl(newUrl);
                this.$message && this.$message.success('编辑成功');
              } else {
                this.$message && this.$message.warning('未获取到编辑后的图片地址');
              }
            }
          });
        } else {
          this.$message && this.$message.error('AI 编辑器未就绪');
        }
      } catch (e) {
        // 避免阻断流程，只记录错误
        // eslint-disable-next-line no-console
        console.error('打开 AI 编辑器失败: ', e);
        this.$message && this.$message.error('打开 AI 编辑器失败');
      }
    },
    messageError(msg) {
      if (this.errMessageIns) {
        return;
      }
      this.errMessageIns = this.$message({
        message: msg,
        type: 'error',
        onClose: () => {
          this.errMessageIns = null;
        }
      })
    },
    // AI生图重试
    handleAiRetry() {
      if (!this.aiStatus || !this.aiStatus.businessId || !this.aiStatus.id || !this.aiStatus.sourceImageUrl) return
      const params = {
        taskCenterId: this.aiStatus.businessId, 
        items: [
          {
            itemId: this.aiStatus.id,
            sourceImageUrl: this.aiStatus.sourceImageUrl,
            sourceIndex: this.aiStatus.sourceIndex
          }
        ]
      }
      const retryFn = typeof this.aiRetryFn === 'function' ? this.aiRetryFn() : this.aiRetryFn
      if (!retryFn) return
      const taskItemsData = typeof this.aiTaskItemsData === 'function' ? this.aiTaskItemsData() : this.aiTaskItemsData
      const matchedTask = taskItemsData?.find?.(t => t.sourceImageUrl === this.imgUrl)
      this.retrying = true
      retryFn(params, (res) => {
        if (res) {
          // 更新任务状态为 RUNNING, aiStatus 计算属性能正确匹配 '正在生图中' 状态
          if (matchedTask) {
            matchedTask.taskStatus = 'RUNNING'
            // matchedTask.resultImageUrl = resultImageUrl
          }
          // this.imgUrl = resultImageUrl
          this.retrying = false
        } else {
          this.retrying = false
        }
      }, () => {
        this.retrying = false
      })
    },
    buildOssImgUrl(url) {
      if(this.size) {
        return buildOssImgUrl(url, this.size);
      }
      return url;
    },
    getNewFileName(file) {
      const originalFilename = file.name; // 获取原始文件名  
      let fileExtension = originalFilename?.substring(originalFilename.lastIndexOf('.')); // 提取文件后缀名  
      if(fileExtension.length > 8) { // 可能原图片没有后缀，取了最后一个 . 后面的当后缀名，导致新图片名称过长
        fileExtension = ''
      }
      const newFileName = new Date().getTime()+'_'+Math.round(Math.random()*100000) + fileExtension;
      return newFileName
    },

    //修改文件名
    changeFile(file){
      const newFileName = this.getNewFileName(file);
      const modifiedFile = file.slice(0, file.size, file.type); // 创建一个新的Blob对象，保留原始文件的内容和类型  
      modifiedFile.name = newFileName; // 设置新文件名  
      // this.fileList.push(modifiedFile); // 将修改后的文件添加到文件列表中  
      return modifiedFile; // 返回修改后的文件对象给上传组件  
    },
    openPictureZone() {
      const that = this;
      this.choosePictrueZoneVisible = true
      this.$nextTick(() => {
        this.$refs.choosePictrueZoneRef.method_open({
          limitSuffix: this.limitSuffix,
          isSingle: this.isSingle,
          okFn(fileList) {
            const urlList = fileList.map(item => item.url)
            if(this.isSingle) {
              that.updateImgUrl(urlList[0])
            } else {
              that.$emit("change", urlList)
            }
          },
        })
      })
    },

    openNewPictureZone() {
      const that = this;
      this.chooseNewPictrueZoneVisible = true
      this.$nextTick(() => {
        this.$refs.chooseNewPictrueZoneRef.method_open({
          limitSuffix: this.limitSuffix,
          isSingle: this.isSingle,
          productCode: this.productIdResolved,
          outerId: this.effectiveOuterId,
          folderId: localStorage.getItem('km_picture_folder_id') || '',
          okFn(fileList) {
            const urlList = fileList.map(item => item.url)
            if (this.isSingle) {
              that.updateImgUrl(urlList[0])
            } else {
              that.$emit("change", urlList)
            }
          },
        })
      })
    },

    // 统一处理素材空间入口的点击逻辑
    handleOpenPictureZone() {
      // if (this.useNewPictureZone) {
        this.openNewPictureZone();
      // } else {
        // this.openPictureZone();
      // }
    },

    beforeUpload(file) {
      this.uploading = true;
      let newFile = this.changeFile(file);
      this.currentUploadFile = newFile;
      this._upload(newFile)
      return false
    },
    updateImgUrl(url) {
      this.imgUrl = url
      this.$emit('upload-success', url)
    },
    handleSettingHighlight(e){
      e.stopPropagation();
      this.$emit('set-as-specification', { imgUrl: this.imgUrl, colorId: this.colorId })
    },
    // 设置为搜索图
    handleSettingSearchImg(e){
      e.stopPropagation();
      this.$emit('set-as-search-img', { imgUrl: this.imgUrl,colorId: this.colorId})
    },
    _upload(file) {
      const success = (res) => {
          this.uploading = false
          this.upload_err = false
          this.errMsg = ''
          this.currentUploadFile = null
          this.updateImgUrl(res.url)
      };
      const fail = (err) => {
          this.uploading = false
          this.upload_err = true
          this.errMsg = '上传失败'
      };
      if (this.uploadFunc) {
        this.uploadFunc(file)
        .then(success)
        .catch(fail)
      } else {
        OSSClient.getInstance().singleUpload(`scm/${this.companyId}/${file.name}`, file, {
          success: success,
          fail: fail
        })
      }
    },
    handleCropFile(file) {
      this.croping = true
      const success = (res) => {
          this.croping = false
          this.updateImgUrl(res.url)
          this.$message.success('裁剪成功')
      };
      const fail = (err) => {
          this.croping = false
          this.$message.error('裁剪失败，请重试')
      };
      // if (this.uploadFunc) {
      //   this.uploadFunc(file)
      //   .then(success)
      //   .catch(fail)
      // } else {
        const newFileName = this.getNewFileName(file);
        OSSClient.getInstance().singleUpload(`scm/${this.companyId}/${newFileName}`, file, {
          success: success,
          fail: fail
        })
      // }
    },
    bufferPush(file) {
      this.fileChangeBuffer.push(file);
      this.resetBufferTimer();
    },
    clearBufferTimer() {
      if (this.bufferTimer) {
        clearTimeout(this.bufferTimer);
        this.bufferTimer = null;
      }
    },
    resetBufferTimer() {
      this.clearBufferTimer();
      this.bufferTimer = setTimeout(() => {
        this.$emit("change", this.fileChangeBuffer);
        this.fileChangeBuffer = [];
      }, 800);
    },
    check_fileWH(file){
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            resolve({width: img.width, height: img.height});
          };
          img.onerror = () => {
            reject(new Error('图片加载失败'));
          };
          img.src = e.target.result;
        };
        reader.onerror = () => {
          reject(new Error('文件读取失败'));
        };
        reader.readAsDataURL(file.raw);
      });
    },

    async handleChange(file) {
      try {
        if (!this._only_testFileType(file)) {
          this.rejectFile('所选文件中有非常规图片格式，已移除');
          return;
        }
        if (!this.check_fileType(file)) {
          this.rejectFile('所选文件中有图片格式不支持，已移除');
          return;
        }
        
        // 如果需要正方形校验，再进行尺寸检查
        if (this.isSquare) {
          const wh = await this.check_fileWH(file);
          if (wh.width !== wh.height) {
            this.messageError('所选文件中长宽比必须1:1，已移除');
            this.fileList = [];
            return;
          }
          if (wh.width < 600 || wh.height < 600) {
            this.messageError('所选文件中长宽需大于等于600*600，已移除');
            this.fileList = [];
            return;
          }
        }
        
        if (this.isSingle) {
          this.fileList = [file];
          this.method_upload();
        } else {
          this.bufferPush(file);
        }
      } catch (error) {
        this.messageError('文件处理失败，请重试');
        this.fileList = [];
      }
    },
    rejectFile(msg) {
      this.messageError(msg);
      this.fileList = [];
    },
    _only_testFileType(file) {
      const fileType = this.getFileSuffix(file);
      return allSuffix.includes(fileType);
    },
    check_fileType(file) {
      const fileTypeArr = (this.limitSuffix || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
      const fileType = this.getFileSuffix(file);
      if (!fileType) return false;
      return fileTypeArr.includes(fileType);
    },
    getFileSuffix(file) {
      const name = file && file.name;
      if (typeof name === 'string') {
        const m = name.match(/\.([^.?]+)(?:\?.*)?$/);
        if (m && m[1]) return `.${m[1].toLowerCase()}`;
      }
      const type = (file && file.type) || (file && file.raw && file.raw.type);
      if (typeof type === 'string' && type.includes('/')) {
        const ext = type.split('/')[1];
        if (ext) return `.${ext.toLowerCase()}`;
      }
      return '';
    },
    edit(isCrop) {
      // 编辑
      if (isCrop) {
        // 裁剪：沿用 LatteSDK 编辑器以保持裁剪体验
        const tasks = [{
          ...this.getWidthAndHeight(),
          backgroundImage: this.imgUrl,
        }]
        this.$refs.editRef.method_open({
          tasks,
          single: true,
          isCrop: true,
          okFn: (newUrlList) => {
            this.updateImgUrl(newUrlList[0])
            this.$message.success('裁剪成功')
          }
        });
      } else {
        // 编辑：打开图片编辑器抽屉（iframe）
        this.imageEditorDrawerVisible = true;
        this.$nextTick(() => {
          this.$refs.imgEditorDrawerRef && this.$refs.imgEditorDrawerRef.method_open({
            imageUrl: this.imgUrl,
            companyId: this.companyId,
          });
        });
      }
    },
    // 图片编辑器保存回调（单图）
    handleImgEditorSave(payload) {
      const url = payload?.url || '';
      if (url) {
        this.updateImgUrl(url);
        this.$message.success('编辑成功');
      } else {
        this.$message.warning('未获取到编辑后的图片地址');
      }
      this.imageEditorDrawerVisible = false;
    },
    // 图片编辑器保存回调（批量）
    handleImgEditorSaveBatch(payload) {
      const urls = Array.isArray(payload?.url) ? payload.url : [];
      if (this.isSingle) {
        if (urls.length) {
          this.updateImgUrl(urls[0]);
          this.$message.success('编辑成功');
        } else {
          this.$message.warning('未获取到编辑后的图片地址');
        }
      } else {
        this.$emit('change', urls);
        this.$message.success('批量编辑成功');
      }
      this.imageEditorDrawerVisible = false;
    },
    del() {
      this.currentUploadFile = null
      if (this.isSingle) {
        this.fileList = []
        this.imgUrl = ''
        this.$emit("del")
      } else {
        this.$emit("del")
      }
    },
    retryUpload() {
      if (!this.currentUploadFile) return
      this.upload_err = false
      this.errMsg = ''
      this.uploading = true
      this._upload(this.currentUploadFile)
    },
    preview() {
      // 获取当前组件的图片列表
      this.previewImageList = this.getImageListForPreview()
      this.previewIndex = this.getCurrentImageIndex()
      this.dialogVisible = true
    },
    
    closePreview() {
      this.dialogVisible = false
    },
    recover(url){// 复原
      this.updateImgUrl(url)
    },
    
    // 获取用于预览的图片列表
    getImageListForPreview() {
      // 如果是单图模式，只返回当前图片
      if (this.isSingle) {
        return this.imgUrl ? [this.imgUrl] : []
      }
      
      // 如果是多图模式，尝试从父组件获取完整图片列表
      const parent = this.$parent
      if (parent && parent.$refs && parent.$refs.imgs) {
        // 从 MutiImgUpload 获取所有图片
        const allImages = []
        parent.$refs.imgs.forEach(imgRef => {
          if (imgRef && imgRef.imgUrl) {
            allImages.push(imgRef.imgUrl)
          }
        })
        return allImages
      }
      
      // 降级方案：只返回当前图片
      return this.imgUrl ? [this.imgUrl] : []
    },
    
    // 获取当前图片在列表中的索引
    getCurrentImageIndex() {
      if (!this.imgUrl) return 0
      
      const index = this.previewImageList.findIndex(img => img === this.imgUrl)
      return index >= 0 ? index : 0
    },
    crop() {
      // 裁剪
      // this.$refs.crop.method_open(this.imgUrl, {
      //   recommendSize: this.cropDefaultSize
      // });
    },
    method_upload() {
      this.$refs.upload.submit()
    },
    // 后端转base64,解决跨域问题
    async getBase64(url, cb) {
      try {
        const match = url.match(/.*\.([^?]*)/)
        if (!match) {
          throw new Error('无法识别文件类型');
        }
        
        const fileType = match[1];
        const prefix = `data:image/${fileType};base64,`;
        
        // 优先使用后端接口
        const res = await getBase64(url, {isNeedLoading: false});
        if (res.result === 1) {
          cb && cb(`${prefix}${res.data}`, fileType);
          return;
        }
        
        // 降级到canvas方案
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL(`image/${fileType === 'jpg' ? 'jpeg' : fileType}`);
          cb && cb(dataURL);
        };
        
        img.onerror = async () => {
          // 最后尝试后端接口
          try {
            const fallbackRes = await getBase64(url, {isNeedLoading: false});
            if (fallbackRes.result === 1) {
              cb && cb(`${prefix}${fallbackRes.data}`, fileType);
            }
          } catch (error) {
            console.error('Base64转换失败:', error);
          }
        };
        
        img.src = url;
      } catch (error) {
        console.error('Base64转换失败:', error);
      }
    },
    //base64转file对象
    base64toFile(base, filename) {
      try {
        const arr = base.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const suffix = mime.split("/")[1];
        const bstr = window.atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);
        
        for (let i = 0; i < n; i++) {
          u8arr[i] = bstr.charCodeAt(i);
        }
        
        return new File([u8arr], `${filename}.${suffix}`, { type: mime });
      } catch (error) {
        console.error('Base64转文件失败:', error);
        return null;
      }
    },
    // 地址转文件对象
    url2File(url) {
      return new Promise((resolve) => {
        if (!url) {
          resolve(false);
          return;
        }
        
        // 先将图片转base64
        this.getBase64(url, (base64) => {
          if (base64) {
            const file = this.base64toFile(base64, 'temp');
            resolve(file);
          } else {
            resolve(false);
          }
        });
      });
    },
    handleLoad(e) {
      this.imgDomReady = true;
      // 清除缓存，强制重新获取尺寸
      this.dimensionsCache = null;
      // 检测 CDN 占位图：404 时返回 1x1 GIF，naturalWidth/naturalHeight 为 0 或 1 判定为无效
      const img = e.target;
      if (img && (img.naturalWidth <= 1 || img.naturalHeight <= 1)) {
        this.imgError = true;
        return;
      }
      this.$emit('handleLoad');
    },
    loadError() {
      this.imgDomReady = true;
      this.imgError = true;
      this.dimensionsCache = null;
      this.$emit('handleLoad');
    },
    // 校验图片地址是否符合限制
    async url_limit(url) {
      const limitRes = await this._file_limit2(this.$refs.originImg || this.$refs.img);
      if (limitRes.success) {
        this.limitError = false;
        return {success: true}
      } else {
        this.limitError = true;
        return {success: false, msg: limitRes.errmsg}
      } 
    },
    async _init_file(file) {
      if (file || file === '') {
        if (typeof file === 'string') {
          if(file.includes('mmecimage.cn')) {
            file = file.replace('mmecimage.cn', 'mmecimage.superboss.cc')
          }
          this.imgUrl = file;
        } else {
          // 是文件对象，则直接上传
          this.fileList = [file];
          this.$nextTick(() => {
            this.method_upload();
          });
        }
      }
    },
    // 校验图片格式是否符合要求
    async method_validImage() {
      if(!this.isCheckImg){
        return
      }
      if (this.validated) {
        return this.valiErrMsg;
      }
      if (!this.elFormItem || !this.file) {
        return '';
      }
      
      try {
        const {success, msg} = await this.url_limit(this.file);
        this.$emit('update:validated', true);
        if (!success) {
          this.$emit('update:valiErrMsg', msg);
          return msg;
        }
        this.$emit('update:valiErrMsg', '');
        return '';
      } catch (error) {
        console.error('图片验证失败:', error);
        this.$emit('update:valiErrMsg', '图片验证失败');
        return '图片验证失败';
      }
    },
    getWidthAndHeight() {
      // 如果已有缓存，直接返回
      if (this.dimensionsCache) {
        return this.dimensionsCache;
      }
      
      const imgDom = this.$refs.originImg || this.$refs.img;
      if (!imgDom) return null;
      
      // 检查图片是否已加载完成
      if (imgDom.complete && imgDom.naturalWidth > 0) {
        this.dimensionsCache = {
          width: imgDom.naturalWidth,
          height: imgDom.naturalHeight
        };
        return this.dimensionsCache;
      }
      
      return null;
    },
    checkImgDomReady() {
      return new Promise((resolve) => {
        if (this.imgDomReady) {
          resolve(true)
        } else {
          const checkInterval = setInterval(() => {
            if (this.imgDomReady) {
              clearInterval(checkInterval);
              resolve(true);
            }
          }, 800)
        }
      })
    },
    _file_limit2(imgDom) {
      // imgDom校验
      return new Promise(async (resolve) => {
        await this.checkImgDomReady();
        if (this.imgError) {
          resolve({errmsg: '图片链接无效或无法访问，请更换图片'});
          return;
        }
        
        try {
          const url = imgDom.src;
          const size = this.limitSize
          const fileTypeArr = (this.limitSuffix || '').split(',')
          const aspectRatioText = this.aspectRatioText
          const minWidth = this.limitWidth[0];
          const maxWidth = this.limitWidth[1];
          const minHeight = this.limitHeight[0];
          const maxHeight = this.limitHeight[1];
          let aspectRatio = this.aspectRatio;
          let aspectRatioRange = this.aspectRatioRange;
          if (aspectRatio) {
            if (Array.isArray(this.aspectRatio)) {
              aspectRatio = this.aspectRatio.map(item => {
                return Number(item.toFixed(2));
              });
            } else {
              aspectRatio = [Number(this.aspectRatio.toFixed(2))];
            }
          }
          const imgWidth = imgDom.naturalWidth;
          const imgHeight = imgDom.naturalHeight;
          let fileType = '';
          if (typeof this.file === 'string') {
            fileType = this.getFileSuffix({ name: this.file });
          } else {
            fileType = this.getFileSuffix(this.file);
          }

          if (fileType) {
            const validTypes = (this.limitSuffix || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
            const isAllowed = validTypes.includes(fileType);
            const isCommon = allSuffix.includes(fileType);

            if (this.strictSuffix ? !isAllowed : (!isAllowed && isCommon)) {
              resolve({errmsg: `图片类型只支持${this.limitSuffix}`});
              this.messageError('所选图片格式不支持');
              this.hasSizeError = false
              return;
            }
          }

          if (size) {
            let resSize;
            if (this.imageCacheSizes[url]) {
              // resSize = this.imageCacheSizes[url];
              resSize = await new Promise(r => _getImageSize(r, resolve, () => this.imageCacheSizes[url], {errmsg: '异常，请重新上传'}));
            } else {
              try {
                this.cacheImageFileSize({url, size: -1})
                // 校验大小
                let reqImageSize = this.$worker ? this.$worker : getImgFileSize;
                let res = await reqImageSize(url, {isNeedLoading: false});
                if (res === 'WorkerError') {
                  res = await getImgFileSize(url, {isNeedLoading: false});
                }
                if (!res || !res.data) {
                  this.cacheImageFileSize({url, size: 0})
                  resolve({errmsg: '异常，请重新上传'})
                  return;
                }
                resSize = res.data;
                this.cacheImageFileSize({url, size: resSize})
              } catch(e) {
                this.cacheImageFileSize({url, size: 0})
              }
            }
            if (resSize > size) {
              const size_M = (size / 1024 / 1024).toFixed(2)
              resolve({errmsg: `大小不能超过${size_M}M`})
              return;
            }
          }
          let hasSizeError = false
          if (minWidth || minHeight || maxHeight || maxWidth || aspectRatio || aspectRatioRange[0] || aspectRatioRange[1]) {
            let ratio = Number((imgWidth / imgHeight).toFixed(2));

            /**
             * 1:1的特殊判断，除完结果可能1.001,1.000001,1.0000001。这里统一如果长宽不等，相差再小也不等，
             * 单独做高宽判断，else判断还是会走到1的情况，这里给个默认1.1的值
             */
            if(ratio===1 && imgWidth!=imgHeight){
              ratio = 1.1;
            }

            if (maxWidth && imgWidth > maxWidth) {
              if(this.needAutoCrop) {
                this.cropImg(imgWidth, imgHeight, 'width', maxWidth, url).then(cropUrl => {
                  this.updateImgUrl(cropUrl)
                })
              } else {
                hasSizeError = true;
                resolve({errmsg: '宽度不能大于' + maxWidth})
              }
            } else if((aspectRatio && !aspectRatio.includes(ratio)) || (aspectRatioRange[0] && ratio < aspectRatioRange[0]) || (aspectRatioRange[1] && ratio > aspectRatioRange[1])) {
              window._d = imgDom;
              resolve({errmsg: '长宽比必须为：' + (aspectRatioText ? aspectRatioText : aspectRatio)});
              hasSizeError = true
            } else if (maxHeight && imgHeight > maxHeight) {
              // 图片高度大于要求，等比例缩小
              if(this.needAutoCrop) {
                this.cropImg(imgWidth, imgHeight, 'height', maxHeight, url).then(cropUrl => {
                  this.updateImgUrl(cropUrl)
                })
              } else {
                resolve({errmsg: '高度不能大于' + maxHeight})
                hasSizeError = true
              }
            } else if (minWidth && imgWidth < minWidth) {
              resolve({errmsg: '宽度不能低于' + minWidth});
              hasSizeError = true
            } else if (minHeight && imgHeight < minHeight) {
              resolve({errmsg: '高度不能低于' + minHeight});
              hasSizeError = true
            }
            // 不同比例图片，图片尺寸要求不一样，因为比例（比例校验在前）已定，只需校验宽度即可，例如（1:1图片像素不低于800*800px 或 3:4比例图片像素不低于750*1000px）
            if(aspectRatio && aspectRatio.includes(ratio) && this.aspectRatioLimitWidth.length) {
              const asIndex = aspectRatio.findIndex(r => r === ratio)
              const asWidthLimit = this.aspectRatioLimitWidth[asIndex] || []
              const minAsWidth = asWidthLimit[0];
              const maxAsWidth = asWidthLimit[1];
              if (maxAsWidth && imgWidth > maxAsWidth) {
                resolve({errmsg: '宽度不能大于' + maxAsWidth});
                hasSizeError = true
              } else if (minAsWidth && imgWidth < minAsWidth) {
                resolve({errmsg: '宽度不能低于' + minAsWidth});
                hasSizeError = true
              }
            }
            resolve({success: true})
          } else {
            resolve({success: true})
          }
          this.hasSizeError = hasSizeError
        } catch (error) {
          console.error('图片校验失败:', error);
          resolve({success: false, errmsg: '图片校验失败'});
        }
      })
    },
    cropImg(width, height, type, max, url) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.crossOrigin = 'Anonymous';
        image.onload = () => {
          let aspectRatio = 0,
            newWidth = 0,
            newHeight = 0;
          if (type === 'width') {  // 图片宽度大于要求，等比例缩小
            aspectRatio = width / height;
            newWidth = max - 1;
            newHeight = Math.floor(newWidth / aspectRatio);
          } else {
            aspectRatio = height / width;
            newHeight = max;
            newWidth = Math.floor(newHeight / aspectRatio);
          }
          // 创建一个 canvas 来压缩图片
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = newWidth;
          canvas.height = newHeight;
          // 清除canvas  
          ctx.clearRect(0, 0, newWidth, newHeight); 
          ctx.drawImage(image, 0, 0, newWidth, newHeight);
          const match = url.match(/.*\.([^?]*)/)
          const fileType = match[1];
          const dataUrl = canvas.toDataURL(`image/${fileType === 'jpg' ? 'jpeg' : fileType}`, 1);
          const file = this.base64toFile(dataUrl, `clip_${new Date().getTime()}_${_.random(99999)}`)
          OSSClient.getInstance().singleUpload(file.name, file, {
              success(res) {
                  resolve(res.url);
              },
              fail() {
                  resolve(url);
              }
          })
        }
      })
    },
    async fixImgSize(){// 一键修正图片尺寸
      let res = await batchFixImages({
        images:[{
          imageUrl:this.imgUrl,
          ...this.autoCropImageParams,
        }]
      });
      if(res && res[0]){
          let item = res[0]
          let oldUrl = item.originalUrl
          let newUrl = item.processedUrl
          let errorText = item.errorMessage
          if(errorText){
            this.$message.error(errorText)
            return;
          }
          if(newUrl){
            // 替换修改后的图片
              this.updateImgUrl(newUrl)
              this.imgCache[newUrl] = oldUrl;
              this.imgUrl = newUrl
          }
      }
    }
  },
  
  created() {
    this._init_file(this.file)
  },
  mounted() {
    if (this.isMainImg || this.isSingle) {
      this.mainImgWatch && this.mainImgWatch()
      this.mainImgWatch = null
      this.mainImgWatch = this.$watch('file', (v) => {
        this._init_file(v)
      })
    }
    OSSClient.getInstance()
  },
  beforeDestroy() {
    this.mainImgWatch && this.mainImgWatch()
    this.choosePictrueZoneVisible = false
  }
}
</script>

<style lang="scss" scoped>
.sc-upload {
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;

  &.croping {
    pointer-events: none;
    &::after {
      content: '编辑中';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.4);
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &.isSingle {
    margin-right: 0;
    margin-bottom: 0;
  }
  &.mainImg {
    .file-img, .file-input {
      // border-color: #396CF3;
      border-style: solid;
    }
  }

  .file-img, .file-input {
    width: 100%;
    height: 100%;
    border-width: 1px;
    border-color: #ccc;
    border-radius: 4px;
    overflow: hidden;
  }
  .file-img.limitError {
    border-color: #F56C6C;
  }
  .file-img {
    border-style: solid;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .file-input {
    border-style: dashed;
  }
  .file-input-icon {
    font-size: 28px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ccc;
    .upload-text {
      font-size: 12px;
      margin-top: 5px;
      padding: 0 3px;
      line-height: 12px;
    }
    .upload-btns {
      display: none;
      height: 100%;
      width: 100%;
      position: absolute;
      flex-direction: column;
      justify-content: center;
      background-color: #fff;
      border: .5px solid #edf0f5;
      border-radius: 2px;
      box-shadow: 0 0 16px rgba(0, 0, 0, .12);
      .location-upload, .material-space-upload, .retry-upload {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1 1;
        color: #030405;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
      }
      .location-upload, .retry-upload {
        border-bottom: 1px solid #edf0f5;
      }
    }

  }
  .error-warp {
    border: 1px solid #F56C6C !important;
  }
  .del-btn, .preview-btn, .crop-btn, .audit-btn,.ai-edit-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    justify-content: center;
    align-items: center;
    color: #fff;
    height: 20px;
    font-size: 12px;
    background-color: rgba(0,0,0,.4);
    z-index: 5;
  }
  .btn-row{
    position: absolute;
    display: none;
    width: 100%;
    font-size: 12px;
    color: #fff;
    bottom: 39px;
    border-bottom: 1px solid #d1caca;
    background-color: rgba(0,0,0,.4);
  }
  .edit-btn,.recover-btn{
    position: relative;
    flex: 1;
    text-align: center;
    cursor: pointer;
  }
  .recover-btn:after{
    position: absolute;
    top: 4px;
    left: 0;
    width: 1px;
    height: 16px;
    background-color: #d1caca;
    content: "";
  }
  &:hover .btn-row, &:hover .del-btn, &:hover .preview-btn, &:hover .crop-btn, &:hover .upload-btns,&:hover .ai-edit-btn {
    display: flex;
  }
  .ai-edit-btn {
    right: 0;
    bottom: 20px;
    left: 0;
    width: 100%;
  }
  .ai-edit-btn:after {
    position: absolute;
    bottom: 0;
    width: 80%;
    height: 1px;
    background-color: #d1caca;
    content: "";
  }
  .crop-btn {
    bottom: 0;
    left: 0;
    width: 50%;
    border-radius: 0 0 0 3px;
    font-size: 14px;
  }
  .crop-btn:after {
    position: absolute;
    top: 4px;
    right: 0;
    width: 1px;
    height: 16px;
    background-color: #d1caca;
    content: "";
  }
  .preview-btn {
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 0 0 3px 3px;
    font-size: 16px;
  }
  .del-btn {
    width: 16px;
    height: 16px;
    top: 0px;
    right: 0px;
    border-radius: 50%;
    // transform: translate(45%, -45%);
  }
  .audit-btn{
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
    top: 0;
    left: 0;
  }
  .imgName {
    font-size: 12px;
    text-align: center;
    color: #606266;
  }
  .mainImgNum {
    position: absolute;
    color: #fff;
    top: 0;
    right: 0;
    z-index: 4;
    font-size: 12px;
    border-top-right-radius: 3px;
    border-bottom-left-radius: 6px;
    background: rgba(24, 144, 255, .8);
    width: 46px;
    height: 23px;
    line-height: 23px;
    text-align: center;
  }
  ::v-deep .el-upload-dragger{
    width: 100%;
    height: 100%;
    border: none;
  }
 .highlight-btn{
  padding: 5px 0px;
   width: 80px;
   margin: 4px 0 0 0;
   display: block;
   position: relative;
   z-index: 999;
 }
 .img-correct-box{
  height: 16px;
  .img-correct-tip{
      line-height: 16px;
      font-size: 12px;
      color: #67C23A;
  }
 }
}
// AI生图状态指示器样式
.ai-status-indicator {
  margin-top: 4px;
  text-align: center;
  .ai-status-text {
    font-size: 12px;
    line-height: 18px;
    &.done {
      color: #67C23A;
    }
    &.failed {
      color: #F56C6C;
    }
    &.pending {
      color: #E6A23C;
    }
    &.retrying {
      color: #409EFF;
    }
  }
  .ai-retry-btn {
    font-size: 12px;
    padding: 0;
    margin-left: 4px;
  }
}
</style>
